import React, { useState } from "react";
import TextSlider from "../TextSlider";
import ReferralSentTab from "./ReferralTabs/ReferralSentTab";
import ReferralReceivedTab from "./ReferralTabs/ReferralReceivedTab";

const ReferralTab = ({ id }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_event, newValue) => {
    setActiveTab(newValue);
  };
  return (
    <>
      <TextSlider
        activeTab={activeTab}
        handleTabChange={handleTabChange}
        tab1="Referrals Sent"
        tab2="Referrals Received"
      />
      {activeTab === 0 && <ReferralSentTab id={id} />}
      {activeTab === 1 && <ReferralReceivedTab id={id} />}
    </>
  );
};

export default ReferralTab;
